import { COMPOUND_ID_DELIMITER } from './consts';

/**
 *  Splits a compound id into parent and entity id.
 *
 *  For example for the following compound id: "p1-p2-p3-p4:e1" the function will return ['p1-p2-p3-p4', 'e1'].
 */
export const splitCompoundId = (compoundId: string) => {
  if (!compoundId.includes(COMPOUND_ID_DELIMITER)) {
    return [];
  }

  return compoundId.split(COMPOUND_ID_DELIMITER);
};
